import React from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
import { HeroSection } from '../components/home/HeroSection';
import { WhatWeDoSection } from '../components/home/WhatWeDoSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { ProductsSection } from '../components/home/ProductsSection';
import { PortfolioSection } from '../components/home/PortfolioSection';
import { WhyChooseUsSection } from '../components/home/WhyChooseUsSection';
import { ProcessSection } from '../components/home/ProcessSection';
import { TrustedBySection } from '../components/home/TrustedBySection';
import { CTASection } from '../components/home/CTASection';
export function HomePage() {
  usePageSEO({
    title: 'Design Flow Digitals',
    description: 'Design Flow Digitals is a premium Shopify development agency with 1,000+ stores delivered. We specialize in custom themes, high-performance apps, and conversion-focused ecommerce stores for global merchants.'
  });
  return <div className="flex flex-col w-full" data-id="element-672">
      <HeroSection data-id="element-673" />
      <WhatWeDoSection data-id="element-674" />
      <ServicesSection data-id="element-675" />
      <ProductsSection data-id="element-676" />
      <PortfolioSection data-id="element-677" />
      <WhyChooseUsSection data-id="element-678" />
      <ProcessSection data-id="element-679" />
      <TrustedBySection data-id="element-680" />
      <CTASection data-id="element-681" />
    </div>;
}